/**
 * Run async work over a list with a fixed number of concurrent workers.
 * Use instead of Promise.all(list.map(fn)) when each item triggers an HTTP call,
 * to avoid browser net::ERR_INSUFFICIENT_RESOURCES and API overload.
 */
export const DEFAULT_API_FETCH_CONCURRENCY = 6;

export async function mapWithConcurrency<T, R>(
  items: T[],
  concurrency: number,
  mapper: (item: T, index: number) => Promise<R>
): Promise<R[]> {
  if (items.length === 0) {
    return [];
  }
  const results: R[] = new Array(items.length);
  const queue = items.map((item, index) => ({ item, index }));
  const workerCount = Math.min(Math.max(1, concurrency), queue.length);

  const workers = Array.from({ length: workerCount }, async () => {
    while (queue.length > 0) {
      const entry = queue.shift();
      if (!entry) {
        break;
      }
      results[entry.index] = await mapper(entry.item, entry.index);
    }
  });

  await Promise.all(workers);
  return results;
}
